export default __webpack_public_path__ + "static/media/go.73c6dbd9.svg";